/**
 * 404 PAGE TEMPLATE
 *
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

function Page403() {

    return (

        <div className="error-403">

            <div className="error-403__title">
                <FormattedMessage id="General_CoreFunctionality_Error_error.forbiddenTitle" />
            </div>

            <div className="error-403__message">
                <FormattedMessage id="General_CoreFunctionality_Error_error.forbiddenMessage" />
            </div>

        </div>

    );

}

export default Page403;


// WEBPACK FOOTER //
// ./src/scripts/pages/ErrorPage/templates/ErrorPage.403.jsx